import React from 'react'
import { Badge as ShadcnBadge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const variantMap: Record<string, string> = {
  primary: 'default',
  secondary: 'secondary',
  danger: 'destructive',
  success: 'default',
  warning: 'default',
  info: 'default',
}

const colorClassMap: Record<string, string> = {
  success: 'bg-[hsl(var(--success))] text-[hsl(var(--success-foreground))]',
  warning: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))]',
  info: 'bg-[hsl(var(--info))] text-[hsl(var(--info-foreground))]',
}

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: string
  pill?: boolean
}

export const Badge: React.FC<BadgeProps> = ({ color = 'primary', pill, className, ...props }) => (
  <ShadcnBadge
    variant={variantMap[color] as any || 'default'}
    className={cn(
      colorClassMap[color],
      pill && 'rounded-full',
      className,
    )}
    {...props}
  />
)
